import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateDependenteColumnsDefinition
 */

type Props = {
  handleActionEdit: (idDependente: number | null) => void,
  handleActionDelete: (idDependente: number) => void,
};

export const GenerateDependenteColumnsDefinition = ({
  handleActionEdit,
  handleActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 80,
      sortable: false,
    },
    {
      field: "grauParentesco",
      filterable: false,
      headerName: "Grau de Parentesco",
      flex: 1,
      minWidth: 80,
      sortable: false,
    },
    {
      field: "rg",
      filterable: false,
      headerName: "RG",
      flex: 0,
      minWidth: 80,
      sortable: false,
    },
    {
      field: "cpf",
      filterable: false,
      headerName: "CPF",
      width: 120,
      sortable: false,
    },
    {
      field: "dataNascimento",
      filterable: false,
      headerName: "Data Nascimento",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>;
      }
    },
    {
      field: 'idDependente',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 0,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => handleActionEdit(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => handleActionDelete(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}